import { render, staticRenderFns } from "./registry_list.vue.js?vue&type=template&id=6531732e!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./registry_list.vue?vue&type=template&id=6531732e"
import script from "./registry_list.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./registry_list.vue?vue&type=script&lang=js"
export * from "./registry_list.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./registry_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports